import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { Subscription } from 'rxjs';
import { InstitutionType } from '@app/models/institution';
import { CountryService } from '@app/services/shared/country.service';
import { Country } from '@app/models/country';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { SortService } from '@app/components/sorting/SortService';
import { ClaimsService } from '@app/services/claims/claims.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';

interface Institution {
  id: number;
  shortName: string;
  name: string;
  seat: string;
}

@Component({
  selector: 'app-searchinstitutions',
  templateUrl: './searchinstitutions.component.html',
  styleUrls: ['./searchinstitutions.component.css']
})
export class SearchinstitutionsComponent implements OnInit, OnDestroy {
  @ViewChild('typ') typ;
  searchactive = false;
  institutions: Institution[] = [];
  institutiontypes: InstitutionType[] = [];
  countries: Country[] = [];
  onlynumbers = '^[0-9]*$';
  subscriptions: Subscription[] = [];
  isExpanded = true;
  role;
 form;

  
  usualmember = false;

  constructor(
    private fb: FormBuilder,
    private permissionsService: PermissionsService,
    private institutionsService: InstitutionsService,
    private countryService: CountryService,
    private router: Router) { }

  ngOnInit() {
    this.form = this.fb.group({
      institutionTypeId: ['', ''],
      institutionNumber: ['', Validators.pattern(this.onlynumbers)],
      belongsTo: ['', ''],
      institutionName: ['', ''],
      organizationNumber: ['', ''],
      street: ['', ''],
      city: ['', ''],
      country: ['', ''],
      email: ['', ''],
      phone: ['', ''],
      swish: ['', ''],
      phoneMobile: ['', ''],
      webSite: ['', ''],
      bankAccount1: ['', ''],
      bankAccount2: ['', '']
    });
    
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        this.getInstitutionTypes();
        if (this.role.institution?.institutionTypeId) {
          this.form.patchValue({ institutionTypeId: this.role.institution.institutionTypeId });
        }
      }
    });
  this.countryService.getCountries().subscribe(c => {
      this.countries = c;
    });
    
    this.permissionsService.selectedrole.subscribe(r => {
      this.role = r;
      this.getInstitutionTypes();
      if (this.role?.institution.institutionTypeId) {
        this.form.patchValue({ institutionTypeId: this.role.institution.institutionTypeId });
        this.searchInstitutions();
      } else {
        this.institutions = [];
        this.form.patchValue({ institutionTypeId: null });
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  getInstitutionTypes() {
    this.subscriptions.push(this.institutionsService.getInstitutionTypes().subscribe(data => {
      this.institutiontypes = data;
      if (this.role?.userPermissionLevel === 'ME') {
        const removelist = ['AV', 'AVGBREV', 'UT', 'EL', 'ELA', 'K', 'RLK', 'RR', 'SOFT'];
        this.institutiontypes = this.institutiontypes.filter(x => {
          return removelist.indexOf(x.prefix) === -1;
        });
      }
    }));
  }

  clear() {
    this.institutions = [];
    this.form.reset();
  }

  viewInstitution(institutionid: number) {
    if (institutionid) {
      this.router.navigate(['/institutions/id/', institutionid]);
    }
  }

  onSubmit() { }

  get institutionNumber() {
    return this.form.get('institutionNumber');
  }

  searchInstitutions() {
    this.subscriptions.push(this.institutionsService.searchInstitutions(this.form.value).subscribe(data => {
      this.institutions = data;
      if (this.institutions.length > 0) {
        const isMobileDevice = window.navigator.userAgent.toLowerCase().includes('mobi');
        isMobileDevice ? this.isExpanded = false : this.isExpanded = true;
      }

      if (this.role.userPermissionLevel === 'ME') {
        const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL1', 'EL2', 'ELA1', 'K', 'RLK', 'RR', 'SOFT1', 'SOFT2', 'EGL1'];
        this.institutions = this.institutions.filter(x => {
          return removelist.indexOf(x.shortName) === -1;
        });
      }
    }));
  }

  searchInstitutions2() {
    this.subscriptions.push(this.institutionsService.searchInstitutions(this.form.value).subscribe(data => {
      this.institutions = data;
      if (this.institutions.length > 0) {
        const isMobileDevice = window.navigator.userAgent.toLowerCase().includes('mobi');
        isMobileDevice ? this.isExpanded = false : this.isExpanded = true;
      }
      if (this.role.userPermissionLevel === 'ME') {
        const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL1', 'EL2', 'ELA1', 'K', 'RLK', 'RR', 'SOFT1', 'SOFT2', 'EGL1'];
        this.institutions = this.institutions.filter(x => {
          return removelist.indexOf(x.shortName) === -1;
        });
      }
    }
    ));
  }

  setType() {
    if (this.role.institution?.institutionTypeId) {
      this.form.patchValue({ institutionTypeId: this.role.institution.institutionTypeId });
    }
  }

  sortData(sort: Sort) {
    const data = this.institutions.slice();
    if (!sort.active || sort.direction === '') {
      this.institutions = data;
      return;
    }

    this.institutions = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'shortName': return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, isAsc);
        case 'name': return this.compare(a.name, b.name, isAsc);
        case 'seat': return this.compare(a.seat, b.seat, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
